<template>
	<div class="login-container">
		<div class="login-form">
			<h2 class="login-title">国家基本公共卫生项目</h2>

			<div class="form-group">
				<label for="username" class="form-label">账号</label>
				<input type="text" id="username" v-model="form.username" class="form-input" placeholder="请输入账号" @blur="validateField('username')" />
				<span v-if="errors.username" class="error-message">{{ errors.username }}</span>
			</div>

			<div class="form-group">
				<label for="password" class="form-label">密码</label>
				<input type="password" id="password" v-model="form.password" class="form-input" placeholder="请输入密码" @blur="validateField('password')" />
				<span v-if="errors.password" class="error-message">{{ errors.password }}</span>
			</div>

			<div class="form-group">
				<div class="captcha-container">
					<label for="password" class="form-label">验证码</label>
					<div class="captcha-slider" :class="{ 'valid-success': captchaText == '验证成功' }">
						<span class="captcha-slider__text" @click="initCaptcha">{{ captchaText }}</span>
						<div class="captcha-slider__thumb" :style="{ left: captchaPosition + 'px' }" :class="{ active: isCaptchaActive }" @mousedown="startCaptcha">
							<span class="captcha-slider__icon">→</span>
						</div>
					</div>
				</div>
				<span v-if="errors.captcha" class="error-message">{{ errors.captcha }}</span>
			</div>

			<button class="login-button" @click="handleLogin" :disabled="isSubmitting">
				{{ isSubmitting ? "登录中..." : "登录" }}
			</button>
		</div>

		<!-- 错误提醒弹窗 -->
		<div v-if="showError" class="error-modal">
			<div class="error-modal__content">
				<button class="error-modal__close" @click="closeErrorModal">×</button>
				<div class="error-modal__title">
					<div class="error-modal__icon">!</div>
					登录失败
				</div>
				<div class="error-modal__message">{{ errorMessage }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getAuth } from "@/service/request";
export default {
	name: "Login",
	data() {
		return {
			form: {
				username: "",
				password: "",
			},
			errors: {
				username: "",
				password: "",
				captcha: "",
			},
			isSubmitting: false,
			// 错误弹窗相关
			showError: false,
			errorMessage: "",
			// 滑块验证码相关
			captchaPosition: 0,
			isCaptchaActive: false,
			isCaptchaValid: false,
			captchaText: "请拖动滑块完成验证",
			// 鼠标事件相关
			isDragging: true,
			startX: 0,
		};
	},
	mounted() {
		document.getElementById("app").style.transform = "";
		localStorage.removeItem("third-token");
	},
	methods: {
		/**
		 * 表单字段验证
		 * @param {string} field - 字段名
		 */
		validateField(field) {
			switch (field) {
				case "username":
					this.errors.username = this.form.username ? "" : "请输入账号";
					break;
				case "password":
					this.errors.password = this.form.password ? "" : "请输入密码";
					break;
				case "captcha":
					this.errors.captcha = this.isCaptchaValid ? "" : "请完成滑块验证";
					break;
			}
		},
		/**
		 * 关闭错误弹窗
		 */
		closeErrorModal() {
			this.showError = false;
			this.errorMessage = "";
		},

		/**
		 * 整体表单验证
		 * @returns {boolean} 是否验证通过
		 */
		validateForm() {
			let isValid = true;

			this.validateField("username");
			this.validateField("password");
			this.validateField("captcha");

			Object.values(this.errors).forEach((error) => {
				if (error) isValid = false;
			});

			return isValid;
		},

		/**
		 * 登录处理
		 */
		handleLogin() {
			if (!this.validateForm()) return;

			this.isSubmitting = true;

			// 构建登录表单数据
			let formData = new FormData();
			// formData.append('account','fushanxian')
			// 	formData.append('password','mb6CrdRX5ADfGgUg%u^F')
			formData.append("account", this.form.username);
			formData.append("password", this.form.password);
			formData.append("appKey", "fushanxian-ehrapi");
			formData.append("appSecret", "B8B533E677914451AEDE5F4A8A3B5F40");

			// 调用登录接口
			getAuth(formData)
				.then((res) => {
					localStorage.setItem("third-token", res.data.ThirdToken);
					this.$router.push("/index");
					this.isSubmitting = false;
				})
				.catch((error) => {
					this.initCaptcha();
					console.error("登录失败:", error);
					this.isSubmitting = false;
					// 显示错误弹窗
					this.errorMessage = "登录失败，请检查账号密码";
					this.showError = true;
				});
		},
		initCaptcha() {
			this.captchaText = "请拖动滑块完成验证";
			this.captchaPosition = 0;
			this.isCaptchaActive = false;
			this.isCaptchaValid = false;
			this.isDragging = true;
		},
		/**
		 * 开始滑块验证
		 * @param {Event} e - 鼠标事件
		 */
		startCaptcha(e) {
			if (!this.isDragging) return;
			this.isDragging = true;
			this.isCaptchaActive = true;
			this.startX = e.clientX;

			// 添加鼠标事件监听器
			document.addEventListener("mousemove", this.onMouseMove);
			document.addEventListener("mouseup", this.stopCaptcha);
		},

		/**
		 * 鼠标移动处理
		 * @param {Event} e - 鼠标事件
		 */
		onMouseMove(e) {
			if (!this.isDragging) return;
			const max = 420 - 40;
			const min = 0;
			const moveDistance = e.clientX - this.startX;
			if (moveDistance > max) {
				this.captchaPosition = max;
			} else if (moveDistance < min) {
				this.captchaPosition = min;
			} else {
				this.captchaPosition = moveDistance;
			}

			// 验证是否成功
			if (this.captchaPosition >= max) {
				this.isCaptchaValid = true;
				this.validateField("captcha");
				this.captchaText = "验证成功";
				this.stopCaptcha();
			}
		},

		/**
		 * 停止滑块验证
		 */
		stopCaptcha() {
			this.isDragging = false;

			// 移除鼠标事件监听器
			document.removeEventListener("mousemove", this.onMouseMove);
			document.removeEventListener("mouseup", this.stopCaptcha);

			// 如果验证未成功，重置位置
			if (!this.isCaptchaValid) {
				// 添加动画效果复位
				setTimeout(() => {
					this.initCaptcha();
				}, 100);
			}
		},
	},
};
</script>

<style lang="stylus" scoped>
.login-container {
    width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form {
  width: 500px;
  flex: none;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 40px;
  opacity: 0;
  transform: translateY(-30px);
  animation: slideDownFadeIn 0.6s ease forwards;
}

@keyframes slideDownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #02a8ae;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.form-group {
    position: relative;
  padding-bottom: 30px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #f0f0f0;
  line-height: 23px;
}

.form-input {
  width: 100%;
  height: 45px;
  padding: 0 15px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #02a8ae;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 0 2px rgba(2, 168, 174, 0.2);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.7);
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  }
}

.error-message {
    position: absolute;
    bottom: 12px;
  display: block;
  font-size: 13px;
  color: #ff4d4f;
  opacity: 0;
  transform: translateY(10px);
  animation: slideUpFadeIn 0.3s ease forwards;
}

@keyframes slideUpFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 滑块验证码样式 */
.captcha-container {
  margin-top: 10px;
}

.captcha-slider {
  position: relative;
  width: 100%;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) inset;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.captcha-slider__thumb {
    user-select none;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
//   transition: all 0.3s ease;
}

.captcha-slider__thumb:hover {
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}

.captcha-slider__thumb.active {
  border-color: #02a8ae;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 6px 16px rgba(2, 168, 174, 0.3);
}

.captcha-slider__icon {
  font-size: 16px;
  color: #007888;
}

.captcha-slider__text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #fff;
  user-select: none;
  transition: all 0.3s ease;
}
.valid-success{
    transition: all 0.3s ease;
    background-color: rgba(155, 255, 205, 0.5);
    &>.captcha-slider__text{
        color: #fff;
    }
}
.login-button {
  width: 100%;
  height: 45px;
  background: rgba(2, 168, 174, 0.8);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

  &:hover {
    background: rgba(2, 168, 174, 0.9);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
  }

  &:disabled {
    background: rgba(204, 204, 204, 0.6);
    cursor: not-allowed;
  }
}

/* 错误提醒弹窗样式 */
.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.error-modal__content {
  width: 400px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  padding: 20px 30px;
  margin: 40px auto;
  animation: slideDownFadeIn 0.5s ease;
  position: relative;
}

.error-modal__icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: rgba(255, 77, 79, 0.2);
  border: 2px solid rgba(255, 77, 79, 0.5);
  border-radius: 50%;
  display: inline-block;
  font-size: 20px;
  font-weight: bold;
  color: #ff4d4f;
  margin-right: 10px;
}

.error-modal__title {
    display: flex;
    align-items: center;
    // justify-content: center

  font-size: 20px;
  font-weight: 600;
  color: #ff4d4f;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  padding-bottom: 10px;
}

.error-modal__message {
  font-size: 16px;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.error-modal__close {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideDownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
